import React from 'react';

import styled from 'styled-components';

import { IStoreDiagnosticData } from 'components/store-diagnostic-modal';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import DiagnosticCogIcon from './diagnostic-cog-icon';
import { FavoriteStoreIcon } from './favorite-store-icon';

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin: 0.625rem;
  position: relative;
`;

const SlimStoreCardIcons: React.FC<{
  storeNumber: string;
  storeId: string;
  diagnosticsEnabled: boolean;
  storeDiagnosticData: IStoreDiagnosticData;
}> = ({ storeId, diagnosticsEnabled, storeDiagnosticData, storeNumber }) => {
  const enableFavorites = useFlag(LaunchDarklyFlag.ENABLE_FAVORITE_STORES);

  return (
    <IconsContainer>
      {enableFavorites && <FavoriteStoreIcon storeId={storeId} storeNumber={storeNumber} />}
      {diagnosticsEnabled && <DiagnosticCogIcon storeDiagnosticData={storeDiagnosticData} />}
    </IconsContainer>
  );
};

export default SlimStoreCardIcons;
